const stableKey = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,40}$/.test(value);
const amount = value => typeof value === 'string' && /^\d+(?:\.\d{1,2})?$/.test(value);
const count = value => Number.isSafeInteger(value) && value >= 0;
const unique = values => new Set(values).size === values.length;
const deadline = value => /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value || '') ? Date.parse(value.replace(' ', 'T') + '+08:00') : NaN;

// 多场公开状态必须自洽；前端不根据最新选项推算次数或奖池份额。
export function validPredictionSeries(state) {
  const rule = state?.rules?.predictionSeries, series = state?.predictionSeries;
  const pages = state?.rules?.pages, progress = state?.progress;
  if (!rule || !series || rule.version !== 2 || series.version !== 2 || state.rules.predictionEntry || state.pagePrediction ||
      !Array.isArray(rule.matches) || !rule.matches.length || !Array.isArray(series.matches) || series.matches.length !== rule.matches.length ||
      !Array.isArray(pages) || !pages.length || pages.length > 30 || !Array.isArray(progress) || progress.length !== pages.length ||
      !unique(rule.matches.map(match => match?.key)) || !unique(series.matches.map(match => match?.key)) ||
      !unique(pages.map(page => page?.key)) || !unique(progress.map(page => page?.key)) ||
      typeof rule.bindPhone !== 'boolean' || typeof rule.bindCard !== 'boolean' || typeof series.poolReady !== 'boolean' ||
      (rule.poolAmount != null && rule.poolAmount !== '' && (!amount(rule.poolAmount) || Number(rule.poolAmount) <= 0 || Number(rule.poolAmount) > 10000000))) return false;
  const perMatchPools = predictionSeriesUsesMatchPools(state);
  const assigned = [];
  for (const match of rule.matches) {
    const own = series.matches.find(row => row?.key === match?.key);
    if (!stableKey(match?.key) || typeof match.title !== 'string' || !match.title || typeof match.templateTitle !== 'string' || !match.templateTitle ||
        !Number.isSafeInteger(match.limit) || match.limit < 1 || match.limit > 99999999 || !/^\d+(?:\.\d{1,2})?$/.test(match.betThreshold || '') || Number(match.betThreshold) > 99999999 ||
        !Number.isFinite(deadline(match.startAt)) || !Number.isFinite(deadline(match.endAt)) || deadline(match.startAt) >= deadline(match.endAt) ||
        !Array.isArray(match.pageKeys) || !match.pageKeys.length || !unique(match.pageKeys) || !own || !count(own.used) || !count(own.remaining) || own.used + own.remaining !== match.limit ||
        typeof own.canPick !== 'boolean' || typeof own.reason !== 'string' || !amount(own.validBetAmount) || own.canPick && (own.remaining === 0 || own.reason !== '') || !own.canPick && own.reason === '') return false;
    if (match.poolAmount != null && match.poolAmount !== '' && (!amount(match.poolAmount) || Number(match.poolAmount) <= 0 || Number(match.poolAmount) > 10000000) || own.poolReady != null && typeof own.poolReady !== 'boolean' || own.claimPageKey != null && (typeof own.claimPageKey !== 'string' || own.claimPageKey !== '' && !match.pageKeys.includes(own.claimPageKey))) return false;
    const poolAmount = perMatchPools ? match.poolAmount : rule.poolAmount;
    const poolReady = perMatchPools ? own.poolReady === true : series.poolReady;
    let used = 0;
    for (const key of match.pageKeys) {
      const page = pages.find(row => row?.key === key), original = progress.find(row => row?.key === key);
      if (!stableKey(key) || !page || page.parentKey !== match.key || page.closeAt !== match.endAt || Number(page.rewardAmount) !== 0 || page.poolAmount ||
          !Array.isArray(page.options) || !page.options.length || page.options.length > 20 || !unique(page.options.map(option => option?.key)) ||
          page.options.some(option => !stableKey(option?.key) || typeof option.title !== 'string' || !option.title.trim()) ||
          !original || !count(original.count) || typeof original.selectedKey !== 'string' || typeof original.winnerKey !== 'string' ||
          (original.count === 0) !== (original.selectedKey === '') || original.selectedKey && !page.options.some(option => option.key === original.selectedKey) ||
          original.winnerKey && !page.options.some(option => option.key === original.winnerKey) || typeof original.completed !== 'boolean' || typeof original.claimed !== 'boolean' ||
          original.completed && (!original.winnerKey || original.count === 0) || original.claimed && (!original.completed || !poolReady || !poolAmount) ||
          (original.currentAmount !== '' && !amount(original.currentAmount))) return false;
      used += original.count;
      assigned.push(key);
    }
    if (used !== own.used || own.claimPageKey && !progress.find(row => row.key === own.claimPageKey)?.completed) return false;
  }
  return assigned.length === pages.length && unique(assigned);
}

// 同场各玩法读取同一个服务端次数对象，换端和切换玩法不会建立独立名额。
export function predictionSeriesSelection(state, pageKey) {
  const rule = state?.rules?.predictionSeries?.matches?.find(match => match.pageKeys?.includes(pageKey));
  return { rule, state: state?.predictionSeries?.matches?.find(match => match.key === rule?.key) };
}

// 这里只守卫公开按钮；真实次数、已绑定事实及奖金仍由原后端事务核验。
export function canPredictionSeriesAction(state, action, pageKey, optionKey = '', now = Date.now()) {
  if (!validPredictionSeries(state)) return false;
  const selected = predictionSeriesSelection(state, pageKey);
  const page = state.rules.pages.find(row => row.key === pageKey), progress = state.progress.find(row => row.key === pageKey);
  if (!page || !progress || !selected.rule || !selected.state) return false;
  if (action === 'PICK') return selected.state.canPick && selected.state.remaining > 0 && now >= deadline(selected.rule.startAt) && now < deadline(selected.rule.endAt) && progress.winnerKey === '' && page.options.some(option => option.key === optionKey);
  const pool = predictionSeriesPool(state, pageKey);
  return action === 'CLAIM' && optionKey === '' && Number(pool.amount) > 0 && pool.ready && (!pool.claimPageKey || pool.claimPageKey === pageKey) && progress.completed && !progress.claimed && amount(progress.currentAmount);
}

// 未确认原请求只保存公开目标与原UUID，不保存认证令牌或客户端奖金。
export function validPredictionPending(value) {
  return Boolean(value && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value.requestId) &&
    ['PICK', 'CLAIM'].includes(value.action) && stableKey(value.targetKey) && (value.action === 'PICK' ? stableKey(value.optionKey) : value.optionKey === ''));
}

// 按冻结规则区分显式单场预算与旧活动级预算，与服务端口径一致。
export function predictionSeriesUsesMatchPools(state) {
  const rule = state?.rules?.predictionSeries;
  return rule?.poolScope === 'match' || Array.isArray(rule?.matches) && rule.matches.some(match => Boolean(match?.poolAmount) || match?.finished === true);
}

// 活动级原封池不能被新响应每场false零值遮蔽，不改变原份额及领取事实。
export function predictionSeriesPool(state, pageKey) {
  const selected = predictionSeriesSelection(state, pageKey), perMatch = predictionSeriesUsesMatchPools(state);
  return {
    amount: (perMatch ? selected.rule?.poolAmount : state?.rules?.predictionSeries?.poolAmount) || '',
    ready: perMatch ? selected.state?.poolReady === true : state?.predictionSeries?.poolReady ?? false,
    claimPageKey: perMatch ? selected.state?.claimPageKey || '' : '',
  };
}

// 分别说明原活动池和显式单场池，不用当前配置重解释原已付预算。
export function predictionSeriesPoolDescription(state) {
  const rule = state?.rules?.predictionSeries;
  if (!rule || !(rule.poolAmount || rule.matches?.some(match => match.poolAmount))) return '本活动不发奖金，不扣款。';
  return predictionSeriesUsesMatchPools(state)
    ? '各场固定奖池独立；本场全部赛果公布后按命中会员均分，同人多次命中只算一份，不扣款。'
    : '整个活动共用一个固定奖池；已公布赛果和原份额按原凭证展示，不扣款。';
}
